import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/styles';
import {Card, CardContent, Grid, Typography, Avatar} from '@material-ui/core';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import {StatusArrow} from 'components';
import {currencyKr} from 'helpers/currencyKr';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%'
    },
    content: {
        alignItems: 'center',
        display: 'flex'
    },
    title: {
        fontWeight: 700
    },
    avatar: {
        backgroundColor: theme.palette.error.main,
        height: 56,
        width: 56
    },
    icon: {
        height: 32,
        width: 32
    },
    statusContainer: {
        marginTop: theme.spacing(2),
        display: 'flex',
        alignItems: 'center'
    },
    status: {
        marginRight: theme.spacing(1)
    },
    up: {
        color: theme.palette.error.main
    },
    down: {
        color: theme.palette.info.main
    },
    middle: {
        color: theme.palette.black
    },
    caption: {
        marginLeft: theme.spacing(1)
    }
}));

const TotalPoint = props => {
    const {className, data, ...rest} = props;
    const classes = useStyles(props);
    const {revenue, status, rate} = data;

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardContent>
                <Grid
                    container
                    justify="space-between"
                >
                    <Grid item>
                        <Typography
                            className={classes.title}
                            color="textSecondary"
                            gutterBottom
                            variant="body2"
                        >
                            Total Revenue
                        </Typography>
                        <Typography variant="h3">
                            {currencyKr(revenue)}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Avatar className={classes.avatar}>
                            <TrendingUpIcon className={classes.icon}/>
                        </Avatar>
                    </Grid>
                </Grid>
                <div className={classes.statusContainer}>
                    <StatusArrow
                        className={classes.status}
                        size="md"
                        type={status || 'middle'}
                    />
                    <Typography
                        className={classes[status]}
                        variant="body2"
                    >
                        {`${rate}%`}
                    </Typography>
                    <Typography
                        className={classes.caption}
                        variant="caption"
                    >
                        Since last day
                    </Typography>
                </div>
            </CardContent>
        </Card>
    );
};

TotalPoint.propTypes = {
    className: PropTypes.string,
    data: PropTypes.object.isRequired
};

export default TotalPoint;
